module.exports = __webpack_public_path__ + "img/instagram.b4f7d6b1.svg";